import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { ALIGNS } from "../consts";

var isInside = function isInside(p, canBe) {
  if (p === ALIGNS.START && canBe[p]) {
    return ALIGNS.START;
  }

  if (p === ALIGNS.END && canBe[p]) {
    return ALIGNS.END;
  }

  return false;
};

var calculateHorizontalPosition = function calculateHorizontalPosition(desiredAnchor, positions) {
  var _canBe;

  var canBe = (_canBe = {}, _defineProperty(_canBe, ALIGNS.START, positions.containerLeft + positions.popoverWidth < positions.windowWidth), _defineProperty(_canBe, ALIGNS.END, positions.containerLeft + positions.containerWidth >= positions.popoverWidth), _canBe);
  var possibleAnchor = desiredAnchor.map(function (p) {
    return isInside(p, canBe);
  }).filter(function (p) {
    return typeof p === "string";
  });
  var posAnchor = possibleAnchor[0];

  if (typeof posAnchor === "string") {
    return posAnchor;
  }

  return null;
};

export default calculateHorizontalPosition;